"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M6 19H2C1.44772 19 1 18.5523 1 18V6.50183C1 6.16632 1.16826 5.85316 1.44803 5.66797L7.94803 1.36537C8.28268 1.14386 8.71733 1.14386 9.05197 1.36537L15.552 5.66797C15.8317 5.85316 16 6.16632 16 6.50183V18C16 18.5523 15.5523 19 15 19H11",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11 19V12H6V19",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;